import { render, staticRenderFns } from "./questionModal.vue?vue&type=template&id=597e85f2&scoped=true&"
import script from "./questionModal.vue?vue&type=script&lang=js&"
export * from "./questionModal.vue?vue&type=script&lang=js&"
import style0 from "./questionModal.vue?vue&type=style&index=0&id=597e85f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597e85f2",
  null
  
)

export default component.exports